span.fileInputWrapper {
  display: flex;
}

/* Hides the browser-rendered input, so we can render our own */
input.fileInput {
  opacity: 0;
  width: 0.1px;
  height: 0.1px;
  position: absolute;
}

label.selectedFile {
  align-content: center;
  padding-left: 1rem;
  color: var(--gray-600);
  overflow-wrap: anywhere;
}

.fileInputBtn {
  display: inline-block;
  border-radius: var(--rounded-default);

  &:focus-within {
    label {
      --button-border-width: 2px;
      border-color: var(--border-color-focus);
      background-color: var(--button-color-primary-focus);
      box-shadow: 0 0 0 4px var(--shadow-color-focus);
      outline: none;
    }
  }
}
